module.exports = __webpack_public_path__ + "img/straight-rail-diagonal-left-top-stone-path.67ace539.png";